import binsMutations from "./mutations.js";
import binsActions from "./actions.js";
import binsGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            selectedPath: "",
            binPermission: "no-access",
        };
    },
    mutations: binsMutations,
    actions: binsActions,
    getters: binsGetters,
};